export const SET_SELECTED_CAR_VARIANT_CODE = 'src/store/metadata/SET_SELECTED_CAR_VARIANT_CODE';
export const SET_SELECTED_CAR_VARIANT_DATA = 'src/store/metadata/SET_SELECTED_CAR_VARIANT_DATA';
export const SET_SELECTED_CAR_MODEL_DATA = 'src/store/metadata/SET_SELECTED_CAR_MODEL_DATA';
export const SET_SIMULATION_CREDIT_DATA = 'src/store/metadata/SET_SIMULATION_CREDIT_DATA';
export const CLEAR_SIMULATION_CREDIT_DATA = 'src/store/metadata/CLEAR_SIMULATION_CREDIT_DATA';
